export { default } from "./RestrictedContentNonStudentUserError";
